import React from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

export enum AUTOBIDDER_CONFIGS_COLUMNS {
  shipper = 'Shipper',
  jobType = 'Job Type',
  jobDescription = 'Job Description',
  status = 'Status',
  mode = 'Mode',
  queueName = 'Queue Name',
  waitTime = 'Wait',
  lastRunStart = 'Last Job Run (Start)',
  lastRunEnd = 'Last Job Run (End)',
  activeJobRunStart = 'Active Job Run (Start)',
  bids = 'Bids',
  // we want the header to also have an 'empty' cell above the clickable arrow
  sidePanelArrow = '',
}

export const TmsTableHeader = () => {
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        {Object.entries(AUTOBIDDER_CONFIGS_COLUMNS).map(([key, value]) => (
          <TableCell
            tableCellType='th'
            dataTest={`${key}-column-header`}
            key={`${key}-column-header`}>
            <div className='rule-header'>{value}</div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
